import { Flex, Image, Box } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { routes } from "config/routes";
import { DiscardDeliveryModal } from "flows/Activities/components/TransportEquipment/DiscardDeliveryModal";
import { useDiscardBlocker } from "flows/Activities/hooks/useDiscardBlocker";
import ConfirmImage from "images/random/confirmation.svg";
import { Page } from "shared/components/Page";
import { Button } from "ui/Button/Button";
import { NavigationHeader } from "ui/NavigationHeader/NavigationHeader";
import { BodyM, HeaderS } from "ui/Typography/Typography";

export function TransportEquipmentConfirmationPage() {
  const intl = useIntl();

  const { isModalOpen, handleDiscard, handleNotDiscard, requestNavigation } = useDiscardBlocker({
    allowedPaths: [routes.activities.deliveryCheckIn.transportEquipmentCount],
  });

  const handleNavigateToTransportEquipmentCount = () => {
    requestNavigation(routes.activities.deliveryCheckIn.transportEquipmentCount);
  };

  return (
    <Page bg="white" isCentered isFull>
      <NavigationHeader
        title={intl.formatMessage({
          id: "components.activities.transport-equipment.confirmation-page.header-title",
        })}
        onClickGoBack={() => requestNavigation(routes.activities.deliveryCheckIn.root)}
      />
      <Flex
        h="full"
        direction="column"
        justifyContent="center"
        align="center"
        maxW="293px"
        textAlign="center"
      >
        <HeaderS mb="s100">
          {intl.formatMessage({
            id: "components.activities.transport-equipment.confirmation-page.title",
          })}
        </HeaderS>
        <BodyM textAlign="center" color="grey.800" mb="s300">
          {intl.formatMessage({
            id: "components.activities.transport-equipment.confirmation-page.body",
          })}
        </BodyM>
        <Image src={ConfirmImage} h="124px" w="124px" />
      </Flex>
      <Box p="s200" w="full">
        <Button variant="primary" isFullWidth onClick={handleNavigateToTransportEquipmentCount}>
          {intl.formatMessage({
            id: "components.activities.transport-equipment.confirmation-page.cta",
          })}
        </Button>
      </Box>
      <DiscardDeliveryModal
        isOpen={isModalOpen}
        onClose={handleNotDiscard}
        onClickPrimary={handleDiscard}
        onClickSecondary={handleNotDiscard}
      />
    </Page>
  );
}
